type SupabaseConfig = { url: string; anonKey: string };

const originOf = (url: string): string | null => {
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
};

/** The project ref in the anon key, or null when the key has none. */
export function projectRef(anonKey: string): string | null {
  try {
    const part = (anonKey.split('.')[1] ?? '').replace(/-/g, '+').replace(/_/g, '/');
    const { ref } = JSON.parse(atob(part.padEnd(Math.ceil(part.length / 4) * 4, '='))) as { ref?: unknown };
    return typeof ref === 'string' && /^[a-z0-9]+$/.test(ref) ? ref : null;
  } catch {
    return null;
  }
}

/** The app calls Supabase on a custom domain, but storage gives upload places on the project host. CLOUD-1314. */
export function storageOrigins({ url, anonKey }: SupabaseConfig): string[] {
  const ref = projectRef(anonKey);
  return [originOf(url), ref && `https://${ref}.supabase.co`].filter((origin): origin is string => !!origin);
}

/** A place storage gave an earlier attempt. Anything else is not sent to with the upload token. */
export function resumableLocation(location: string | null, config: SupabaseConfig): string | undefined {
  const origin = location ? originOf(location) : null;
  if (!location || !origin || !storageOrigins(config).includes(origin)) return undefined;
  return new URL(location).pathname.startsWith('/storage/v1/upload/resumable/') ? location : undefined;
}
